import React, { PureComponent } from 'react';
import { DropdownItem } from 'reactstrap';
import { func } from 'prop-types';
import { FMessage } from '@hoc/IntlComponents';
import { FlowSubAccountView } from '../index';

class FlowSubAccount extends PureComponent {
  static propTypes = {
    onSubAccountChange: func.isRequired,
  };

  static defaultProps = {
    onSubAccountChange() {},
  };

  state = {
    open: false,
    subAccount: '',
  };

  toggle = () => {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  };

  setPreset = preset => {
    this.setState(
      () => ({
        subAccount: preset,
      }),
      () => {
        this.props.onSubAccountChange(this.state.subAccount);
      },
    );
  };

  handleChange = e => {
    const target = e.target;

    this.setState(
      () => ({
        [target.name]: target.value,
      }),
      () => {
        this.props.onSubAccountChange(target.value);
      },
    );
  };

  renderPresets = (presets = {}) =>
    Object.keys(presets).map(preset => (
      <DropdownItem onClick={() => this.setPreset(presets[preset])} key={preset}>
        {preset === 'vk_public' ? <FMessage id="flow.form.subs.label.vk" /> : preset}
      </DropdownItem>
    ));

  render() {
    const { subAccount, open } = this.state;

    return (
      <FlowSubAccountView
        subAccount={subAccount}
        open={open}
        renderPresets={this.renderPresets}
        toggle={this.toggle}
        onChange={this.handleChange}
      />
    );
  }
}

export default FlowSubAccount;
